import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const approachSteps = [
  {
    title: "Detailed Engineering Planning",
    description: "Detailed engineering planning and system design for robust infrastructure.",
    icon: "Clipboard"
  },
  {
    title: "Professional Installation",
    description: "Expert installation and professional system integration services.",
    icon: "Settings"
  },
  {
    title: "Quality Verification",
    description: "Testing, commissioning, and quality verification for ultimate reliability.",
    icon: "CheckSquare"
  },
  {
    title: "Preventive Maintenance",
    description: "Continuous monitoring and preventive maintenance to ensure long-term value.",
    icon: "Activity"
  }
];

const ApproachSection = () => {
  return (
    <section className="py-24 bg-slate-50 border-t border-slate-100 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Our Approach</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter">
              A Structured Engineering <br />
              <span className="text-[#91756A]">Process</span> for Reliability.
            </h3>
            <p className="text-slate-500 text-lg leading-relaxed mb-12 max-w-xl">
              Every project at VASTECH follows a structured engineering process designed to ensure reliability, 
              performance, and long-term value. This process allows us to deliver solutions that operate 
              efficiently throughout the lifecycle of the building.
            </p>
            
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: "100px" }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, duration: 1 }}
              className="h-2 bg-[#91756A] mb-12"
            ></motion.div>
          </motion.div>

          <div className="grid gap-6">
            {approachSteps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="flex items-start space-x-6 bg-white p-8 border-l-2 border-slate-100 hover:border-[#91756A] hover:translate-x-4 transition-all duration-300 shadow-sm"
              >
                <div className="flex-shrink-0 w-12 h-12 bg-slate-50 rounded-sm flex items-center justify-center">
                  <Icon name={step.icon} size={20} className="text-[#91756A]" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-[#4D4C4A] mb-2 italic tracking-tighter uppercase">{step.title}</h4>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;